// stores/vehicleForGpsStore.js
'use client';

import useSWR from 'swr';
import FilterBuilder from '../utils/filterBuilder';
import { fleetApiGo } from '../api/axiosClient';
import { useMemo } from 'react';

const getTzParam = () => `?tz=${Math.abs(new Date().getTimezoneOffset() / 60)}`;

const fetcher = async ([url, payloadStr]) => {
  try {
    const payload = typeof payloadStr === 'string' ? JSON.parse(payloadStr) : payloadStr;
    const response = await fleetApiGo.post(url + getTzParam(), payload);
    return response;
  } catch (err) {
    console.error('API fetcher error:', { url, payloadStr, status: err?.response?.status, data: err?.response?.data });
    throw err;
  }
};

export const useVehicleForGpsList = (page = 0, rowsPerPage = 1000, searchKey = 'license_plate', searchValue = '', extraColumns = []) => {
  const start = page * rowsPerPage;

  const payload = useMemo(() => {
    const fb = new FilterBuilder().setPaging(start, rowsPerPage).setOrder(['license_plate'], true);
    fb.addJoin('company', ['name']);

    if (searchValue && searchValue.trim() !== '') {
      fb.like(searchKey || 'license_plate', searchValue, 'AND');
    }

    // Append extra columns via FilterBuilder
    if (Array.isArray(extraColumns) && extraColumns.length > 0) {
      extraColumns.forEach((col) => {
        if (!col) return;
        fb.where(col.logic_operator ?? '=', col.name ?? '', col.value ?? '', col.operator ?? 'AND');
      });
    }

    return fb.build();
  }, [start, rowsPerPage, searchKey, searchValue, extraColumns]);

  const key = useMemo(() => ['/vehicle-for-gps/search', JSON.stringify(payload)], [payload]);

  const { data, error, isLoading } = useSWR(key, fetcher, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    shouldRetryOnError: false,
    keepPreviousData: true,
    revalidateOnMount: true
  });

  return {
    data: data?.data?.data ?? data?.data ?? [],
    totalRecord: data?.data?.totalRecord ?? data?.data?.totalRecords ?? data?.data?.dataSize ?? data?.totalRecord ?? 0,
    isLoading,
    isError: error
  };
};
